/*
Copyright (c) 2025 Protected HayeNii
All rights reserved. Unauthorized use, copying, or modification is prohibited.
*/

// Validation function
function validateField(field) {
  if (!field) return false;
  const value = field.value;
  return value && value.trim().length > 0;
}

// Simplified protection that won't interfere with normal browser behavior
const _protect = {
  init: function () {
    // Only apply basic protections
    document.addEventListener("contextmenu", (e) => {
      if (!window.Shopify?.designMode) {
        e.preventDefault();
      }
    });

    // Basic keyboard shortcuts protection
    document.addEventListener("keydown", (e) => {
      if (window.Shopify?.designMode) return; // Skip in design mode

      if (e.ctrlKey || e.metaKey) {
        // Prevent common dev shortcuts
        if (["s", "u", "i"].includes(e.key.toLowerCase())) {
          e.preventDefault();
          return false;
        }
      }
    });
  },
};

(function (w, d) {
  "use strict";

  // Protected styles with responsive font sizing
  const _styles = `
    <style>
        #outputBox {
            font-size: clamp(60px, 15vw, 120px);
            text-align: center;
            padding: 20px;
            margin: 20px 0px 0px 0px;
            min-height: 0px;
            line-height: 1.2;
            border-radius: 8px;
            color: #000;
            width: 100%;
            overflow-wrap: break-word;
            word-wrap: break-word;
            word-break: break-all;
        }
            input#inputField {
    border: 1px solid #333 !important;
}
        @media screen and (min-width: 1024px) {
            #outputBox {
                font-size: clamp(50px, 8vw, 100px);
            }
        }
     /* Only hide when no selection has been made */
#fontSelector:not([value]),
#fontSelector[value=""],
#fontSelectorLabel:has(+ #fontSelector:not([value])),
#fontSelectorLabel:has(+ #fontSelector[value=""]),
#s2id_fontSelector:has(select:not([value])),
#s2id_fontSelector:has(select[value=""]) {
    display: none !important;
}
        .font-preview-grid {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
            gap: 15px;
            padding: 15px;
            margin: 20px 0;
        }
        .font-preview-item {
            border: 1px solid #e5e5e5;
            border-radius: 8px;
            padding: 20px 15px;
            text-align: center;
            cursor: pointer;
            transition: all 0.2s ease;
            background: white;
        }
        .font-preview-item:hover {
            border-color: #c7ab62;
            transform: translateY(-2px);
            box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }
        .font-preview-item.selected {
            border: 2px solid #c7ab62;
            background: #fafafa;
        }
        .preview-text {
            font-size: 32px;
            margin-bottom: 10px;
            min-height: 40px;
        }
        .preview-label {
            font-size: 12px;
            color: #666;
        }
        #countrySelector,
        #countrySelector option {
            font-family: inherit;
            font-size: inherit;
            color: inherit;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            cursor: pointer;
        }
    </style>`;

  // Inject protected styles
  d.head.insertAdjacentHTML("beforeend", _styles);

  // Protected translation service
  const _ts = (function () {
    const _config = {
      apiKey: "AIzaSyApMOV0t6PhuBdjjlnINBztpI0nGIEX5oE",
      baseUrl: "https://translation.googleapis.com/language/translate/v2",
    };

    class _Service {
      constructor() {
        this.state = {
          originalText: "",
          translatedText: "",
          currentFont: "",
          currentLanguage: "",
        };
      }

      async translateText(text, targetLang = "pa", sourceLang = "en") {
        try {
          const response = await fetch(
            `${_config.baseUrl}?key=${_config.apiKey}`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                q: text,
                target: targetLang,
                source: sourceLang,
              }),
            }
          );

          if (!response.ok) throw new Error("Translation failed");

          const data = await response.json();
          this.state.translatedText = data.data.translations[0].translatedText;
          return this.state.translatedText;
        } catch (error) {
          console.error("Translation error:", error);
          return text;
        }
      }

    

updateDisplay(text) {
  const outputBox = d.getElementById("outputBox");
  const gurmukhiInput = d.getElementById("gurmukhiText");
  const devanagariInput = d.getElementById("devanagariText");
  const urduInput = d.getElementById("urduText");

  if (outputBox) {
    outputBox.textContent = text;
    const selectedFont = this.state.currentFont || this.getDefaultFont(this.state.currentLanguage);
    outputBox.style.fontFamily = `${selectedFont}, Arial, sans-serif`; // Fallback to Arial if font fails
    console.log(`Setting font to: ${selectedFont}`); // Helps us debug
  }

  if (gurmukhiInput) {
    gurmukhiInput.value = this.state.currentLanguage === "Punjabi" ? text : "";
  }

  if (devanagariInput) {
    devanagariInput.value = this.state.currentLanguage === "Hindi" ? text : "";
  }
  if (urduInput) {
  urduInput.value = this.state.currentLanguage === "Urdu" ? text : "";
}

  const nameInput = d.querySelector('input[name="properties[Name that you choose]"]');
  if (nameInput) {
    nameInput.value = this.state.originalText;
  }
}


      
getDefaultFont(language) {
  if (language === "Punjabi") return "Font1P";
  if (language === "Hindi") return "Font1H";
  if (language === "Urdu") return "Font1U";
  return "Font1";
}

  
createFontPreviews(text) {
  const container = d.createElement("div");
  container.className = "font-preview-grid";

 const fonts =
  this.state.currentLanguage === "Punjabi"
    ? this._getPunjabiFonts()
    : this.state.currentLanguage === "Hindi"
    ? this._getHindiFonts()
    : this.state.currentLanguage === "Urdu"
    ? this._getUrduFonts()
    : this._getEnglishFonts();

  fonts.forEach((font) => {
    const previewItem = d.createElement("div");
    previewItem.className = "font-preview-item";
    if (font.value === this.state.currentFont) previewItem.classList.add("selected");

    previewItem.innerHTML = `
      <div class="preview-text" style="font-family: ${font.value}, Arial, sans-serif">${text}</div>
      <div class="preview-label">${font.text}</div>
    `;

    previewItem.onclick = (e) => {
      e.preventDefault();
      e.stopPropagation();

      d.querySelectorAll(".font-preview-item").forEach((item) =>
        item.classList.remove("selected")
      );
      previewItem.classList.add("selected");

      const fontSelector = d.getElementById("fontSelector");
      fontSelector.value = font.value;
      fontSelector.dispatchEvent(new Event("change")); // Tell Select2 we changed it
      this.state.currentFont = font.value;

      this.updateDisplay(text);
    };

    container.appendChild(previewItem);
  });

  const existingPreview = d.querySelector(".font-preview-grid");
  if (existingPreview) {
    existingPreview.replaceWith(container);
  } else {
    const inputField = d.getElementById("inputField");
    inputField.parentElement.insertBefore(container, d.getElementById("outputBox"));
  }
}
      
      _getPunjabiFonts() {
        return [
          { value: "Font1P", text: "ਅੱਖਰ 1" },
          { value: "Font2P", text: "ਅੱਖਰ 2" },
          { value: "Font3P", text: "ਅੱਖਰ 3" },
          { value: "Font4P", text: "ਅੱਖਰ 4" },
          { value: "Font5P", text: "ਅੱਖਰ 5" },
          { value: "Font6P", text: "ਅੱਖਰ 6" },
          { value: "Font7P", text: "ਅੱਖਰ 7" },
          { value: "Font8P", text: "ਅੱਖਰ 8" },
          // { value: "Font9P", text: "ਅੱਖਰ 9" },
          // { value: "Font10P", text: "ਅੱਖਰ 10" },
          { value: "Font11P", text: "ਅੱਖਰ 9" },
        ];
      }

      _getEnglishFonts() {
        return [
          { value: "Font1", text: "Font 1" },
          { value: "Font2", text: "Font 2" },
          { value: "Font3", text: "Font 3" },
          { value: "Font4", text: "Font 4" },
          { value: "Font5", text: "Font 5" },
          { value: "Font6", text: "Font 6" },
          { value: "Font7", text: "Font 7" },
          { value: "Font8", text: "Font 8" },
        ];
      }
      _getHindiFonts() {
  return [
    { value: "Font1H", text: "अक्षर 1" },
    { value: "Font2H", text: "अक्षर 2" },
    { value: "Font3H", text: "अक्षर 3" },
    { value: "Font4H", text: "अक्षर 4" },
    { value: "Font5H", text: "अक्षर 5" },
    { value: "Font6H", text: "अक्षर 6" },
    { value: "Font7H", text: "अक्षर 7" },
    { value: "Font8H", text: "अक्षर 8" },
    // { value: "Font9H", text: "अक्षर 9" },
  ];
}

      _getUrduFonts() {
  return [
    { value: "Font1U", text: "فونٹ 1" },
    { value: "Font2U", text: "فونٹ 2" },
    { value: "Font3U", text: "فونٹ 3" },
    { value: "Font4U", text: "فونٹ 4" },
    { value: "Font5U", text: "فونٹ 5" },
    { value: "Font6U", text: "فونٹ 6" },
    { value: "Font7U", text: "فونٹ 7" },
    { value: "Font8U", text: "فونٹ 8" }
  ];
}
    }

    return new _Service();
  })();

  
async function _updatePreview(input) {
  if (!input.value || input.value.trim() === "") {
    const outputBox = d.getElementById("outputBox");
    if (outputBox) {
      outputBox.textContent = "";
    }
    const existingPreview = d.querySelector(".font-preview-grid");
    if (existingPreview) {
      existingPreview.remove();
    }
    return;
  }

  const selectedLanguage = d.getElementById("countrySelector").value;
  _ts.state.currentLanguage = selectedLanguage;
  _ts.state.originalText = input.value;

  let displayText = input.value;

  const isPunjabiText = (text) => {
    return /[\u0A00-\u0A7F]/.test(text);
  };

  const isHindiText = (text) => {
    return /[\u0900-\u097F]/.test(text);
  };
  const isUrduText = (text) => /[\u0600-\u06FF]/.test(text);

  if (selectedLanguage === "Punjabi" && !isPunjabiText(input.value)) {
    displayText = await _ts.translateText(input.value, "pa");
  } else if (selectedLanguage === "Hindi" && !isHindiText(input.value)) {
    displayText = await _ts.translateText(input.value, "hi");
  } else if (selectedLanguage === "Urdu" && !isUrduText(input.value)) {
    displayText = await _ts.translateText(input.value, "ur");
  }

  // Update the hidden fields based on language
  if (selectedLanguage === "Punjabi") {
    const gurmukhiText = d.getElementById("gurmukhiText");
    if (gurmukhiText) gurmukhiText.value = displayText;
  } else if (selectedLanguage === "Hindi") {
    const devanagariText = d.getElementById("devanagariText");
    if (devanagariText) devanagariText.value = displayText;
  } else if (selectedLanguage === "Urdu") {
    const urduText = d.getElementById("urduText");
    if (urduText) urduText.value = displayText;
  }

  _ts.updateDisplay(displayText);
  _ts.createFontPreviews(displayText);
}
  

  // Initialize
  d.addEventListener("DOMContentLoaded", () => {

document.fonts.ready.then(() => {
  console.log("Fonts are ready!");
  const inputField = document.getElementById("inputField");
  if (inputField && inputField.value) {
    _updatePreview(inputField);
  }
});

    
    const countrySelector = d.getElementById("countrySelector");
    if (countrySelector) {
      countrySelector.addEventListener("change", async () => {
        const inputField = d.getElementById("inputField");
        if (inputField && inputField.value) {
          await _updatePreview(inputField);
        }

        const specifyLanguageDiv = d.querySelector(".specify_language");
        if (specifyLanguageDiv) {
          specifyLanguageDiv.style.display =
            countrySelector.value === "Other" ? "block" : "none";
        }
      });
    }

// Form submission handler
const form = d.querySelector('form[action="/cart/add"]');
if (form) {
  form.addEventListener("submit", function (e) {
    const requiredFields = ["inputField"];
    const hasEmptyRequired = requiredFields.some((fieldId) => {
      const field = d.getElementById(fieldId);
      return !validateField(field);
    });

    if (hasEmptyRequired) {
      e.preventDefault();
      alert("Please enter a name before adding to cart!");
      return false;
    }

    // Save the selected font
    const fontSelector = d.getElementById("fontSelector");
    if (fontSelector && fontSelector.value) {
      let fontStyleInput = form.querySelector('input[name="properties[Font Style]"]');
      if (!fontStyleInput) {
        fontStyleInput = document.createElement('input');
        fontStyleInput.type = 'hidden';
        fontStyleInput.name = 'properties[Font Style]';
        form.appendChild(fontStyleInput);
      }
      fontStyleInput.value = fontSelector.value;
    }

    // Save the language
    const countrySelector = d.getElementById("countrySelector");
    if (countrySelector) {
      let languageInput = form.querySelector('input[name="properties[Language]"]');
      if (!languageInput) {
        languageInput = document.createElement('input');
        languageInput.type = 'hidden';
        languageInput.name = 'properties[Language]';
        form.appendChild(languageInput);
      }
      languageInput.value = countrySelector.value;

      // Handle "Other" language specification
      const specificLanguageInput = d.getElementById("language_input_field");
      if (specificLanguageInput && countrySelector.value === "Other") {
        let specifyLanguageInput = form.querySelector('input[name="properties[Your specify language]"]');
        if (!specifyLanguageInput) {
          specifyLanguageInput = document.createElement('input');
          specifyLanguageInput.type = 'hidden';
          specifyLanguageInput.name = 'properties[Your specify language]';
          form.appendChild(specifyLanguageInput);
        }
        specifyLanguageInput.value = specificLanguageInput.value;
      }
    }

    // Save the name and translated text
    const inputField = d.getElementById("inputField");
    if (inputField && inputField.value) {
      let nameInput = form.querySelector('input[name="properties[Name that you choose]"]');
      if (!nameInput) {
        nameInput = document.createElement('input');
        nameInput.type = 'hidden';
        nameInput.name = 'properties[Name that you choose]';
        form.appendChild(nameInput);
      }
      nameInput.value = inputField.value;

      const lang = countrySelector ? countrySelector.value : "";
      if (lang === "Punjabi") {
        const gurmukhiText = d.getElementById("gurmukhiText");
        if (gurmukhiText) {
          let gurmukhiInput = form.querySelector('input[name="properties[Gurmukhi Name]"]');
          if (!gurmukhiInput) {
            gurmukhiInput = document.createElement('input');
            gurmukhiInput.type = 'hidden';
            gurmukhiInput.name = 'properties[Gurmukhi Name]';
            form.appendChild(gurmukhiInput);
          }
          gurmukhiInput.value = gurmukhiText.value || d.getElementById("outputBox").textContent;
        }
      } else if (lang === "Hindi") {
        const devanagariText = d.getElementById("devanagariText");
        if (devanagariText) {
          let devanagariInput = form.querySelector('input[name="properties[Devanagari Name]"]');
          if (!devanagariInput) {
            devanagariInput = document.createElement('input');
            devanagariInput.type = 'hidden';
            devanagariInput.name = 'properties[Devanagari Name]';
            form.appendChild(devanagariInput);
          }
          devanagariInput.value = devanagariText.value || d.getElementById("outputBox").textContent;
        }
      } else if (lang === "Urdu") {
        const urduText = d.getElementById("urduText");
        if (urduText) {
          let urduInput = form.querySelector('input[name="properties[Urdu Name]"]');
          if (!urduInput) {
            urduInput = document.createElement('input');
            urduInput.type = 'hidden';
            urduInput.name = 'properties[Urdu Name]';
            form.appendChild(urduInput);
          }
          urduInput.value = urduText.value || d.getElementById("outputBox").textContent;
        }
      }
    }
  });
}


    

    // Initialize protection
    _protect.init();
  });

  // Expose minimal interface
  w.updatePreview = _updatePreview;
})(window, document);
